import { useState } from "react";
import { Col, Tooltip } from "reactstrap";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { formatCurrency, formatNumber, formatShortDate } from "../utils/formatUtils";

// Grid of social media post cards. Shared by BestPostsCards and TrackedAccountPosts.
const PostCards = ({ posts, selectedCurrency }) => {
  const { t } = useTranslation();
  const [tooltipStates, setTooltipStates] = useState({});

  const toggleTooltip = (id) => {
    setTooltipStates(prevState => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };

  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {posts.filter(post => post && post.id).map((post) => {
        // Create unique IDs for each tooltip in this post
        const impressionId = `impression-${post.id}`;
        const engagementId = `engagement-${post.id}`;
        const valueId = `value-${post.id}`;
        const engValueId = `engValue-${post.id}`;
        const timestampId = `timestamp-${post.id}`;

        return (
          <Col key={post.id} xs={12} sm={6} md={4} lg={4} className="mb-3">
            <a href={post.permalink} target="_blank" rel="noreferrer" className="post">
              <div className="post-card">
                <div className="post-card-image">
                  {post.media_type === 'VIDEO' ? (
                    <div className="post-card-media-video">
                      <video src={post.s3_url} alt="" className="post-card-media" />
                      <i className='fa fa-play post-card-media-video-icon'/>
                    </div>
                  ) : (
                    <img src={post.s3_url} alt="" className="post-card-media" />
                  )}
                  <div className="post-card-image-icon">
                    {post.media === 'facebook' && <div style={{ backgroundColor: '#117197' }}><FaFacebook /></div>}
                    {post.media === 'instagram' && <div style={{ backgroundColor: '#E9B42C'}}><FaInstagram /></div>}
                  </div>
                </div>
                <div className="p-2">
                  <div className="post-card-message">
                    {post.message}
                  </div>
                  <div className="post-card-footer">

                    <span className="post-stat" id={timestampId}>
                       {formatShortDate(post.timestamp, selectedCurrency)}
                    </span>
                    <Tooltip placement="top" isOpen={tooltipStates[timestampId]} target={timestampId} toggle={() => toggleTooltip(timestampId)}>
                      {t('When this post was published')}
                    </Tooltip>

                    <span className="post-stat" id={impressionId}>
                      👀 {formatNumber(post.impression, selectedCurrency)}
                    </span>
                    <Tooltip placement="top" isOpen={tooltipStates[impressionId]} target={impressionId} toggle={() => toggleTooltip(impressionId)}>
                      {t('post_impressions_tooltip')}
                    </Tooltip>

                    <span className="post-stat" id={engagementId}>
                      👏 {formatNumber(post.engagement, selectedCurrency)}
                    </span>
                    <Tooltip placement="top" isOpen={tooltipStates[engagementId]} target={engagementId} toggle={() => toggleTooltip(engagementId)}>
                      {t('post_engagement_tooltip')}
                    </Tooltip>

                    <span className="post-stat" id={valueId}>
                      💰 {formatCurrency(post.value || 0, selectedCurrency)}
                    </span>
                    <Tooltip placement="top" isOpen={tooltipStates[valueId]} target={valueId} toggle={() => toggleTooltip(valueId)}>
                      {t('post_value_tooltip')}
                    </Tooltip>

                    <span className="post-stat" id={engValueId}>
                      🏆 {formatCurrency(post.engagementValue || 0, selectedCurrency)}
                    </span>
                    <Tooltip placement="top" isOpen={tooltipStates[engValueId]} target={engValueId} toggle={() => toggleTooltip(engValueId)}>
                      {t('post_engagement_value_tooltip')}
                    </Tooltip>
                  </div>
                </div>
              </div>
            </a>
          </Col>
        );
      })}
    </div>
  );
};

export default PostCards;
